import { render, staticRenderFns } from "./companyDuplication.vue?vue&type=template&id=250d52cb&scoped=true"
import script from "./companyDuplication.vue?vue&type=script&lang=js"
export * from "./companyDuplication.vue?vue&type=script&lang=js"
import style0 from "./companyDuplication.vue?vue&type=style&index=0&id=250d52cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250d52cb",
  null
  
)

export default component.exports